import { BaseLogicClass } from "../edit.baseLogic";
import { EDIT_MODE_KIND } from "../edit.const";
import { itemVenderProperty } from "../edit.sonbp_if";


/**
 * 写真・スタンプ系用の基底クラス
 */
export abstract class BaseStampLogicClass extends BaseLogicClass {

// #region ■定数・変数

    protected readonly VIEW_TITLE: string;              // 見出し
    protected readonly VIEW_MODE: string;               // 処理モード
    protected readonly VIEW_ITEM_TYPE: string;          // 処理対象のアイテム種別
    protected readonly PUT_MAX: number;                 // 配置可能な数

// #endregion

// #region ■イベント

    /**
     * ツールメニュー：スタンプ押下メソッド
     * @summary 編集モードをスタンプにして画面表示を切り替える。
     */
    abstract btnClickStampMenu(this:BaseLogicClass, event: JQueryEventObject): void;

    /**
     * 操作パネル→スタンプアイテム編集ボタン押下メソッド(SP用)
     * @summary モードに合わせてボタン活性状態を設定する。
     */
    public btnClickEditStampItem(event: JQueryEventObject): void {

        // タッチイベント制御(有効)
        this._edctrl.touchEventChange(true);

        this.setStampEditMode();
    }

    /**
     * スタンプの位置調整画面に戻るボタン押下(SP用)
     * @summary 配置済みスタンプあれば位置調整画面へ戻る。０件ならメイン画面へ戻る。
     */
    public returnStampHomeBtn(event: JQueryEventObject): void {

        let that = this;

        // スタンプの存在チェック
        this.sonbpIfController.getItems([this.VIEW_ITEM_TYPE],
            (list: itemVenderProperty[]) => {

                if (list.length === 0) {
                    // スタンプが０件の場合には、ホームに戻る
                    that._edctrl.btnClickReturnHome(true, true, null);
                }
                else {
                    // タイトル
                    that._vue.$data.Header.Title = that.VIEW_TITLE;

                    // パネルの表示制御
                    that.setShowFlgAllOFF();
                    that._vue.$data.Show.ReturnHomeExBtn = true;
                    that._vue.$data.Show.CommitNextHomeBtn = true;
                    that._vue.$data.Show.StampDeleteBtn = true;
                    that._vue.$data.Show.EditArea = true;
                    that._vue.$data.Show.FooterMenu = true;
                    that._vue.$data.Show.OparatePallet = true;

                    // 削除ボタンの活性制御
                    that._vue.$data.Stamp.DelBtnEnable = (0 < list.length) ? true : false;

                    // オブジェクト操作メニュー
                    that._edctrl.setModeOparatePalletForSp(that.VIEW_MODE, null);

                    // タッチイベント制御(無効)
                    that._edctrl.touchEventChange(false);
                }
            },
            () => { });
    }

// #endregion

// #region ■内部関数

    /**
     * スタンプ編集モードへ画面項目設定(SP用)
     * @summary モードに合わせてボタン活性状態を設定する。
     */
    abstract setStampEditMode(this: BaseLogicClass): void;

    /**
     * （共通部分）
     *  @summary 現在使用中(スタンプ、Myステッカー、手書きスタンプ)の数
     */
    protected UseCount(): number {
        let count = 0;
        if (this.VIEW_MODE == EDIT_MODE_KIND.MYSTAMP) {
            this.sonbpIfController.getMyStampList((list) => {
                count = list.length;
            })
            return count;
        }
        else if (this.VIEW_MODE == EDIT_MODE_KIND.STAMP) {
            this.sonbpIfController.getMstStampList((list) => {
                count = list.length;
            })
            return count;
        }
        else if (this.VIEW_MODE == EDIT_MODE_KIND.FONTGENIC) {
            this.sonbpIfController.getTegakiStampList((list) => {
                count = list.length;
            })
            return count;
        }
        return count;
    }

// #endregion

}
